import React from 'react';
import CustomerInlineLabelInput from 'components/Customer/CustomerInlineLabelInput';
import { PropTypes } from 'prop-types';
import { Field, FormSection } from 'redux-form';
import { DidYouMeanCombo } from 'components/Common/DidYouMeans/DidYouMeanCombo';
import TaxRegime from 'common/Customers/TaxRegime';
import AddressType from 'components/Customer/CustomerAddressType';

const AddressFields = ({ isEditable, index, addressType, regime, isPrimary, jurisdictions,
  onRemoveAddress, handleChangeAddressRegime, onMakePrimaryClick, isMailingPrimaryEditable
}) => {
  const addressHeader = addressType === 'mailing' ? 'Mailing' : 'Residence';

  const hasRegimeFlag = value => (regime & value) === value;

  return (
    <div className="customer-form-panel">
      <div className="panel">
        <div className="panel-data">
          <div className="columns">
            <div className="col-12">
              <div className="form-group address-pills">
                <h3 className="col-3" id={ `${ addressType }-address-header-${ index + 1 }` }>
                  <strong>{`${ addressHeader } ${ index + 1 }`}</strong>
                </h3>
                <div className="pills col-9">
                  {isEditable && <button
                    className="btn btn-sm btn-danger"
                    type="button"
                    onClick={ () => onRemoveAddress(addressType, index) }
                    disabled={ !isEditable }
                  >
                    <span className="icon icon-delete" id={ `remove-${ addressType }-address-${ index }` } />
                  </button>}
                  {isPrimary
                   && <div
                     className="chip chip--active"
                     title="This address is used as the primary address"
                     id={ `primary-${ addressType }-address-pill-${ index }` }
                   >
                     PRIMARY
                   </div>}
                  {addressType === AddressType.permanent && !isPrimary && isEditable
                  && <button
                    type="button"
                    className="chip chip--address chip--make-primary"
                    title="Click here to make this Address the Primary (used for the Prepopulation of Form Data and Data Exports)"
                    onClick={ () => onMakePrimaryClick(index) }
                    id={ `make-primary-${ addressType }-address-button-${ index }` }
                  >
                    PRIMARY</button>}
                  {addressType === AddressType.mailing && !isPrimary && (isEditable || isMailingPrimaryEditable)
                    && <button
                      type="button"
                      className="chip chip--address chip--make-primary"
                      title="Click here to make this Address the Primary (used for the Prepopulation of Form Data and Data Exports)"
                      onClick={ () => onMakePrimaryClick(index) }
                      id={ `make-primary-${ addressType }-address-button-${ index }` }
                    >
                      PRIMARY</button>}
                  {addressType === AddressType.permanent && hasRegimeFlag(TaxRegime.fatca) && <div
                    className="chip chip--address chip--fatca"
                    title="This address is used for FATCA"
                    id={ `fatca-perm-address-pill-${ index }` }
                  >FATCA
                  </div>}
                  {isEditable && addressType === AddressType.permanent && !hasRegimeFlag(TaxRegime.fatca) && <button
                    type="button"
                    className="chip chip--address chip--make-fatca"
                    title="Click here to make this Address used for FATCA"
                    onClick={ () => handleChangeAddressRegime(index, TaxRegime.fatca) }
                    id={ `make-fatca-perm-address-button-${ index }` }
                  >FATCA
                  </button>}
                  {addressType === AddressType.permanent && hasRegimeFlag(TaxRegime.crs) && <div
                    className="chip chip--address chip--crs"
                    title="This address is used for CRS"
                    id={ `crs-perm-address-pill-${ index }` }
                  >CRS
                  </div>}
                  {isEditable && addressType === AddressType.permanent && !hasRegimeFlag(TaxRegime.crs) && <button
                    type="button"
                    className="chip chip--address chip--make-crs"
                    title="Click here to make this Address used for CRS"
                    onClick={ () => handleChangeAddressRegime(index, TaxRegime.crs) }
                    id={ `make-crs-perm-address-button-${ index }` }
                  >CRS
                  </button>}
                </div>
              </div>
              <FormSection name="address">
                <Field
                  name="line1"
                  component={ CustomerInlineLabelInput }
                  isEditable={ isEditable }
                  label="Line 1"
                  id={ `customer-${ addressType }-address[${ index }]-line1` }
                />
                <Field
                  name="line2"
                  component={ CustomerInlineLabelInput }
                  isEditable={ isEditable }
                  label="Line 2"
                  id={ `customer-${ addressType }-address[${ index }]-line2` }
                />
                <Field
                  name="line3"
                  component={ CustomerInlineLabelInput }
                  isEditable={ isEditable }
                  label="Line 3"
                  id={ `customer-${ addressType }-address[${ index }]-line3` }
                />
                <Field
                  name="line4"
                  component={ CustomerInlineLabelInput }
                  isEditable={ isEditable }
                  label="Line 4"
                  id={ `customer-${ addressType }-address[${ index }]-line4` }
                />
                <Field
                  name="postalCode"
                  component={ CustomerInlineLabelInput }
                  isEditable={ isEditable }
                  label="Postal Code"
                  id={ `customer-${ addressType }-address[${ index }]-postal-code` }
                />
                <div className="form-group columns">
                  <label className="form-label col-3" id={ `customer-${ addressType }-address[${ index }]-country-label` }>Country</label>
                  <span className="col-8">
                    <Field
                      name="country"
                      component={ DidYouMeanCombo }
                      items={ jurisdictions?.map(x => x.name) ?? [] }
                      disabled={ !isEditable }
                      className="form-select"
                      id={ `customer-${ addressType }-address[${ index }]-country` }
                    />
                  </span>
                </div>
              </FormSection>
            </div>
          </div>
        </div>
      </div>
    </div>);
};

AddressFields.propTypes = {
  isEditable: PropTypes.bool,
  index: PropTypes.number.isRequired,
  addressType: PropTypes.string.isRequired,
  regime: PropTypes.number,
  isPrimary: PropTypes.bool,
  jurisdictions: PropTypes.arrayOf(PropTypes.shape()),
  onRemoveAddress: PropTypes.func,
  handleChangeAddressRegime: PropTypes.func,
  onMakePrimaryClick: PropTypes.func,
  isMailingPrimaryEditable: PropTypes.bool
};

AddressFields.defaultProps = {
  isEditable: false,
  regime: 0,
  isPrimary: false,
  jurisdictions: null,
  onRemoveAddress: null,
  handleChangeAddressRegime: null,
  onMakePrimaryClick: null,
  isMailingPrimaryEditable: false
};

export default AddressFields;
